<template>
  <el-row type="flex" justify="center" class="my-content">
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm"
             class="ruleForm">
      <el-header class="my-header" height="28vh">
        <h1 style="font-size: xx-large">执信孵化器知识产权检索系统</h1>
        <img src="../assets/logo.png" alt="logo" style="width: 300px;height: auto;max-width: 100%;margin: 0 auto;">
      </el-header>
      <el-form-item label="用户名" prop="username">
        <el-input v-model.number="ruleForm.username"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="pass">
        <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
      <el-row justify="center">
        <el-button type="text" @click="ba">返回主页</el-button>
      </el-row>
    </el-form>
  </el-row>
</template>

<script>
export default {
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.username !== '') {
          this.$refs.ruleForm.validateField('username')
        }
        callback()
      }
    }
    const checkUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        pass: '',
        username: ''
      },
      rules: {
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        username: [
          { validator: checkUsername, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post(this.apiUrl + '/sys/login', this.ruleForm)
            .then((response) => {
              // console.log(response)
              if (response.status === 200 && response.data) {
                sessionStorage.setItem('jId', this.ruleForm.username + ',' + response.data.jId)
                this.$router.replace('/').then()
              } else {
                this.$alert('用户名或密码错误', '提示', {
                  confirmButtonText: '确定'
                })
                return false
              }
            })
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    ba () {
      window.open('http://tj-joinscience.com/', '_self')
    }
  }
}
</script>

<style scoped>
  .my-content{
    height: 100%;
    background: url("../assets/bg2.jpg");
    background-size: cover;
  }
  .ruleForm{
    width: 520px;
    text-align: center;
  }
  .my-header {
    display: flex;
    flex-direction: column-reverse;
    text-align: center;
    margin-bottom: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue